import { render, staticRenderFns } from "./BaseShareSentiment.vue?vue&type=template&id=9ccedbf6&"
import script from "./BaseShareSentiment.vue?vue&type=script&lang=js&"
export * from "./BaseShareSentiment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib'
installComponents(component, {VSwitch})
